import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    standalone: false,
    selector: "switcher",
    templateUrl: "./switcher.component.html",
    styleUrls: ["./switcher.component.css"],
})
export class SwitcherComponent {
    @Input() isChecked: boolean;
    @Output() isCheckedChange = new EventEmitter();
    @Input("editable") editable: boolean = true;
    @Output("onChange") onChange: EventEmitter<any> = new EventEmitter<any>();

    onValueChange(event) {
        this.isCheckedChange.emit(this.isChecked);
        if (this.onChange) {
            this.onChange.emit({ event: event, newValue: this.isChecked });
        }
    }
}
